import React from 'react';
import { IconCreditCard } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const PaymentMethods = () => (
    <SimpleLookupCrud
        icon={IconCreditCard}
        gradient="teal"
        title="Formas de Pagamento"
        subtitle="Dinheiro, PIX, cartão, boleto..."
        endpoint="payment-methods"
        addLabel="Nova forma de pagamento"
        columns={[
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'is_active', label: 'Ativo', type: 'checkbox', default: true }
        ]}
    />
);

export default PaymentMethods;
